/* ANTI Labs — free-shipping claim → cart surfaces (2026-07-10)

   When the free-shipping popup's completion action has set the
   'antiFreeShipClaimed' localStorage flag (the same flag the top bar reads),
   the cart reflects the unlocked state everywhere it talks about shipping:

     • the free-shipping progress bar (drawer + cart page — same classes)
       reads "Free shipping unlocked", full fill, no $x/$100 fraction;
     • the drawer receipt's Shipping row reads "Free" instead of
       "At checkout" (and drops the muted tone — it's a real value now).

   The bar's default state is computed server-side in Liquid
   (snippets/cart-drawer.liquid), which can't see localStorage — so this
   layer applies the claimed state client-side and RE-applies after every
   drawer/cart re-render (renderContents replaces innerHTML, wiping DOM
   edits). MutationObservers watch the cart roots; every write is guarded
   (only set when different) so the observers can't feed back on their own
   mutations. Purely additive presentation — no cart math, no commerce
   logic, and the checkout's actual free shipping comes from the popup's
   discount, not from here. */

(function () {
  'use strict';

  var MSG = 'Free shipping unlocked';
  var FREE = 'Free';

  function claimed() {
    /* Session-scoped 2026-08-22 (Remy): the flag alone is not enough — the
       per-tab marker proves the claim happened THIS browsing session. The
       top-bar script (custom-top-bar.liquid) owns stamping the marker and
       expiring markerless flags; this reader just honors the pair. */
    try {
      return localStorage.getItem('antiFreeShipClaimed') === 'true' &&
             sessionStorage.getItem('antiFreeShipSession') === 'true';
    }
    catch (e) { return false; }
  }

  function apply() {
    if (!claimed()) return;

    /* Progress bar — drawer and cart page share the cc-cart__ship classes. */
    document.querySelectorAll('.cc-cart__ship').forEach(function (el) {
      el.classList.add('cc-cart__ship--unlocked');
      var msg = el.querySelector('.cc-cart__ship-msg span');
      if (msg && msg.textContent !== MSG) msg.textContent = MSG;
      var totals = el.querySelector('.cc-cart__ship-totals');
      if (totals && !totals.hidden) totals.hidden = true;
      var fill = el.querySelector('.cc-cart__ship-fill');
      if (fill && fill.style.width !== '100%') fill.style.width = '100%';
    });

    /* Receipt Shipping row (drawer) — hook added in cart-drawer.liquid. */
    document.querySelectorAll('[data-cc-ship-value]').forEach(function (dd) {
      if (dd.textContent.trim() !== FREE) {
        dd.textContent = FREE;
        dd.classList.remove('cc-cart__foot-row-r--muted');
      }
    });
  }

  function boot() {
    apply();
    /* Re-apply after any cart re-render. Observed roots are the custom
       elements whose innerHTML Shopify's cart JS replaces. */
    ['cart-drawer', 'cart-items', 'cart-drawer-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el) new MutationObserver(apply).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
